// /notifications — NotificationsInboxPage. V1 demo = empty inbox.

import { EmptyState } from '../shell/index.js';
import { useI18n } from '../i18n/index.js';

export function NotificationsPage() {
  const { t } = useI18n();
  return (
    <EmptyState
      eyebrow={t('shell.notifications.eyebrow')}
      headline={t('shell.notifications.headline')}
      body={t('shell.notifications.body')}
    />
  );
}
